// Email API utility for sending form submissions to AWS Lambda

const API_ENDPOINT = import.meta.env.VITE_EMAIL_API_URL || '';

/**
 * Send email via Lambda API
 * @param {'contact' | 'newsletter'} type - Email type
 * @param {Object} data - Form data
 * @returns {Promise<{message: string, messageId?: string}>}
 */
async function sendEmail(type, data) {
  if (!API_ENDPOINT) {
    console.warn('VITE_EMAIL_API_URL not configured');
    throw new Error('Email service not configured');
  }

  try {
    const response = await fetch(`${API_ENDPOINT}/send-email`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        type,
        data,
      }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.details || 'Failed to send email');
    }

    return await response.json();
  } catch (error) {
    console.error('Email API error:', error);
    throw error;
  }
}

/**
 * Send contact form submission
 * @param {Object} data - Contact form data
 * @param {string} data.name - Full name
 * @param {string} data.email - Email address
 * @param {string} [data.company] - Company name (optional)
 * @param {string} [data.phone] - Phone number (optional)
 * @param {string} data.subject - Message subject
 * @param {string} data.message - Message content
 */
export const sendContact = (data) => sendEmail('contact', data);

/**
 * Send newsletter subscription
 * @param {Object} data - Newsletter data
 * @param {string} data.email - Email address
 */
export const sendNewsletter = (data) => sendEmail('newsletter', data);

export const emailApi = {
  sendContact,
  sendNewsletter,
};
